/**
 * 회원 기록 모달 — $j.F.Admin.Member.Logs
 *
 *   $j.F.Admin.Member.Logs.changes(21429);  // 변경내역 (g5_member_logs)
 *   $j.F.Admin.Member.Logs.logins(21429);   // 로그인기록 (g5_login_log)
 *
 * 기사편집 하단 버튼(Pages/Admin/MemberEdit/Actions)과 회원 팝오버(Member/Pop)가 **같은 창**을 띄운다.
 * 페이지 모듈 안에 두면 기사편집 밖(접수목록·입출금 등)에서 여는 팝오버는 닿지 못한다.
 * 스타일(.ml-*·.me-pg)은 adm.css 에 전역으로 들어 있다 (sass/admin/pages/_member-edit-v2.scss).
 */
import Util from '../../../Common/Util';

export default class Logs {

    /** rel_action → 사람이 읽는 이름·색. 없는 값은 코드 그대로 보여준다(새 액션이 생겨도 안 사라지게). */
    static CHANGE_NAME = {
        FEE_GROUP:   ['유료/무료',  'warn'],    // 파급이 커서 따로 뺀 액션 (MemberLogService)
        EDIT:        ['정보변경',   'info'],
        CMS:         ['CMS',        'ok'],
        ID_CHANGE:   ['아이디변경', 'warn'],
        CHRSOO:      ['차수변경',   'info'],
        'NO-FEE':    ['회비감면',   'ok'],
        LEAVE:       ['탈퇴',       'danger'],
        TRANSFER:    ['소유권이전', 'warn'],
        BD_JOIN:     ['서비스가입', 'info'],
        LOC_CONSENT: ['위치약관',   'info'],
        MK_CONSENT:  ['마케팅동의', 'info'],
        EDIT_DROP:   ['편집반려',   'warn'],
        CASH_EDIT:   ['캐시정정',   'warn'],   // 수동입출금 행 수정 (CashEditService)
        CASH_DELETE: ['캐시삭제',   'danger'],
        DOC_MOVE:    ['서류이동',   'info'],    // 관리자 서류창에서 다른 종류로 옮김 (DocMoveService)
        RELATION:    ['차단·특차',  'warn'],    // 회원이 거는 수발주제한·특차의 등록·변경·해제 (MemberRelationService)
        PARTNER_GUIDE: ['협력사안내', 'info'],  // 협력사 오더 첫 수주 안내 불러톡 (협력사별 1회)
        DORMANT:     ['휴면전환',   'warn'],    // 일배치(LG유플러스 업체발주자 1년 미접속, 처리자 없음) 또는 CS 서비스상태 저장 (MemberDormantService)
        DORMANT_RELEASE: ['휴면해제', 'ok'],    // 기사관리 [휴면해제]
        CAR_MAX:     ['최대장비',   'warn'],    // 최대 장비대수 변경 — CS 수정 · 추가등록비 (MemberLogService::ACT_CAR_MAX)
    };

    /**
     * 변경내역 (`g5_member_logs`).
     *
     * 차수기록(CHRSOO)은 기본으로 빼고 본다 — 안 그러면 탈퇴·소유권이전 같은 드문 사건이
     * 차수줄에 파묻힌다. 몇 건을 감췄는지는 화면이 말해주고, 눌러서 펼 수 있다.
     * 15건씩 쪽을 나눈다(서버 MemberController::memberLogs) — '전부 보기' 를 누르면 1쪽부터 다시 센다.
     *
     * 모달은 **한 번만 열고 본문만 갈아끼운다.** 쪽마다 JBModal.html() 로 다시 열면 여는
     * 애니메이션(페이드·확대)이 매번 돌아 쪽을 넘길 때마다 깜빡인다.
     */
    static changes(mbNo) {
        const ID = 'member-logs-modal';
        const esc = (v) => $('<i>').text(v == null ? '' : v).html();

        $j.Ui.JBModal.html(ID, '<div class="ml-empty" style="padding:24px;text-align:center">로딩중...</div>',
            '변경 로그', { width: '820px' });
        const $modal = $(`#${ID}`);
        const $body  = $modal.find('.ui-modal__body');
        let all = false;

        // 이벤트는 $body 위임 — 본문을 통째로 다시 그리므로 버튼에 직접 걸면 두 번째 렌더부터 죽는다.
        $body.on('click', '.js-ml-all', () => { all = true; draw(1); })
             .on('click', '.me-pg__btn', (e) => draw(Util.int($(e.currentTarget).data('page'))));

        const draw = (page = 1) => {
            $.ajax({ url: `/adm/ajax/member/${mbNo}/logs`, data: { all: all ? 1 : 0, page }, dataType: 'json' })
                .done((d) => {
                    if (!d.result) { $j.F.Admin.Util.tsalert('error', d.message || '조회 실패'); return; }

                    const hidden = all ? 0 : (d.counts?.CHRSOO || 0);
                    const rows = (d.list || []).map((l) => {
                        const [label, tone] = this.CHANGE_NAME[l.rel_action] || [l.rel_action, 'info'];
                        // rel_id 는 액션마다 뜻이 다르다 — 차수는 차수값, 감면은 적용 년월.
                        // ⚠ `rel_id` 는 문자열로 온다 — `"0"` 은 truthy 라 그냥 두면 참조번호로 '0' 이 찍힌다.
                        //    쓰지 않는 액션(EDIT·CMS·ID_CHANGE …)은 0 을 넣으므로 숫자로 판정한다.
                        const ref = Number(l.rel_id) ? `<span class="ml-ref">${esc(l.rel_id)}</span>` : '';
                        return `<tr>
                            <td class="ml-when">${esc(l.created_at)}</td>
                            <td><span class="ml-act ml-act--${tone}">${esc(label)}</span>${ref}</td>
                            <td class="ml-desc">${esc(l.rel_desc)}</td>
                            <td class="ml-who">${esc(l.manage_name || (l.rel_action === 'RELATION' ? '회원' : '시스템'))}</td>
                        </tr>`;
                    }).join('');

                    const body = `<div class="ml-wrap">
                        ${hidden ? `<div class="ml-note">차수변경 ${hidden}건은 숨겼습니다.
                            <button type="button" class="me-btn js-ml-all">전부 보기</button></div>` : ''}
                        <table class="ml-tbl">
                            <thead><tr><th style="width:150px">시각</th><th style="width:130px">내용</th>
                                       <th>상세</th><th style="width:100px">처리자</th></tr></thead>
                            <tbody>${rows || '<tr><td colspan="4" class="ml-empty">기록이 없습니다.</td></tr>'}</tbody>
                        </table>
                        ${$j.F.Admin.Util.pager(d)}
                    </div>`;

                    $modal.find('.ui-modal__title').text(`변경 로그 — ${d.mem_name || '회원'}#${mbNo}`);
                    $body.html(body);
                })
                .fail((xhr) => $j.F.Admin.Util.tsalert('error', `조회 중 오류가 발생했습니다. (${xhr.status})`));
        };

        draw(1);
    }

    /** 로그인기록 (`g5_login_log` — 1년 보관. 로그인 말고 밀려남·기기 전환·잠김·비번 변경도 남는다) */
    static logins(mbNo) {
        $j.F.Admin.Util.showLoginLogs({
            url:     `/adm/ajax/member/${mbNo}/login-logs`,
            title:   '로그인 기록',
            modalId: 'member-login-logs-modal',
        });
    }
}
